<template>
  <div class="row mt-3">
    <div class="col-md-12">
      <ValidationObserver ref="validator">
        <div class="row">
          <div class="col-12 col-md-2">
            <ValidationProvider
              v-slot="{ errors }"
              mode="eager"
              rules="required"
            >
              <custom-date-picker
                v-model="model.ogpDate"
                format="dd/MM/yyyy"
                :use-utc="false"
                label="Fecha:"
                placeholder="DD/MM/YYYY"
                :error="errors[0]"
                custom-error-msg="Favor selecciona la fecha."
                class="custom-datetime-picker-container"
                :max-date="new Date()"
                :disabled="readonly"
              />
            </ValidationProvider>
          </div>
          <div class="col-12 col-md-6">
            <ValidationProvider
              v-slot="{ errors }"
              mode="eager"
              rules="required"
            >
              <custom-input
                v-model="model.ogpNumber"
                :error="errors[0]"
                label="Número de Planeamiento:"
                custom-error-msg="Favor escriba el número de planteamiento."
                label-class="data-label number-input"
                :disabled="readonly"
              />
            </ValidationProvider>
          </div>
          <div
            v-if="!readonly"
            :class="['col-12 col-md-4', { 'my-4': isMobile }]"
          >
            <div class="d-flex justify-content-end h-100 align-items-end">
              <action-button
                class="btn-mobile mr-3 px-3"
                variant="outline-danger"
                i="fas fa-times-circle"
                text="Cancelar"
                @click="onCancel()"
              />
              <action-button
                class="btn-mobile px-3 btn-ok"
                variant="success"
                i="fas fa-save"
                text="Guardar"
                @click="saveChanges()"
              />
            </div>
          </div>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomDatePicker from 'custom-date-picker';
import CustomInput from '@/components/common/CustomInput';
import ActionButton from 'ActionButton';
import { saveRequestOgp, getRequestOgp } from '@/modules/human-resources/api';
import mixAlert from '@/mixin/alert.mixin';
import objectToFormData from 'object-to-formdata';

export default {
  name: 'Ogp',
  mixins: [mixAlert],
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomDatePicker,
    CustomInput,
    ActionButton,
  },
  data() {
    return {
      model: {
        requestId: null,
        ogpDate: null,
        ogpNumber: null,
      },
      readonly: true,
    };
  },
  props: {
    requestId: {
      type: Number,
      required: true,
    },
  },
  async mounted() {
    await getRequestOgp(this.requestId).then((res) => {
      if (res.data.ogpNumber != null) {
        this.model.ogpDate = res.data.ogpDate;
        this.model.ogpNumber = res.data.ogpNumber;
        this.readonly = true;
      } else {
        this.readonly = false;
      }
    });
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },

  methods: {
    async saveChanges() {
      if (!(await this.$refs.validator.validate())) return;

      this.model.requestId = this.requestId;
      let formData = objectToFormData(this.model);

      await saveRequestOgp(formData).then(() => {
        this.readonly = true;
        this.ShowToast(
          'Proceso exitoso',
          'El número de planteamiento ha sido guardado exitosamente.',
          'success'
        );
      });
    },
    onCancel() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-mobile.px-3.ab-btn.btn-ok:not(:hover) {
  background: #2db782 !important;
}

::v-deep .width-container {
  width: auto !important;
}
::v-deep .form-control:disabled {
  border: none !important;
}
</style>
